import { paymentsModule } from 'apps/payments/src';
import { OpenSansFontFace } from 'libs/uikit/fonts/OpenSans';
import { UIKitFonts } from 'libs/uikit/fonts/UIKitFonts';
import { Module } from 'libs/uikit/ioc';
import { createInjector } from 'libs/uikit/ioc/Core/Injector';
import { InjectorContext } from 'libs/uikit/ioc/React';
import { UIProvider, createTheme } from 'libs/uikit/lib';
import React from 'react';
import { appconfig } from 'services/web/react/config/appconfig';
import { FeatureFlagProvider } from 'services/web/react/featureflags/launchdarkly';
import { notificationsModule } from 'services/web/react/src/Notifications/NotificationsModule';
import { ocsModule } from 'services/web/react/src/OCSModule';
import { CoreModule } from '../core/CoreModule';
import { bearIQModule } from '../src/BearIQ/BearIQModule';

const theme = createTheme({
  body: {
    font: {
      fontFamily: 'Open Sans, sans-serif',
      fontSize: '13px',
    },
  },
});

const root = new Module({
  imports: [
    CoreModule,
    paymentsModule({
      paymentsApiUrl: appconfig.payments.endpoint,
    }),
    notificationsModule({
      notificationsApiUrl: appconfig.notifications.endpoint,
    }),
    ocsModule({
      webApiUrl: window.location.origin,
    }),
    bearIQModule({
      webApiUrl: window.location.origin,
    }),
  ],
});

const rootInjector = createInjector(root);
(window as any).rootInjector = rootInjector;

interface ProvidersProps {
  children?: React.ReactNode;
}

export function Providers(props: ProvidersProps) {
  return (
    <React.StrictMode>
      {/* opensans is a font used by old anguarljs ui */}
      <OpenSansFontFace />

      <UIKitFonts />

      <InjectorContext injector={rootInjector}>
        <UIProvider theme={theme}>
          <FeatureFlagProvider>{props.children}</FeatureFlagProvider>
        </UIProvider>
      </InjectorContext>
    </React.StrictMode>
  );
}
